export const VITRINS_FILTERS_DROPDOWN_TEXTS = {
  POPULAR: 'По популярности',
  RATE: 'по ставке',
  SUM_UP: 'по сумме больше',
  SUM_DOWN: 'по сумме меньше',
};
